module.exports = __webpack_public_path__ + "img/php.99e43586.svg";